export default "__VITE_ASSET__D1kCuA0X__"